import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { finalize, map } from 'rxjs/operators';

import { environment } from '../../../../../environments/environment';
import { RoutingPath } from './../../../../configs/routing-path';
import { IContribuyente } from './../../../../core/models/business-information/ibusiness-information';
import { IUser } from './../../../../core/models/user/user';
import { LocalStorageService } from './../../../../core/services/local-storage/local-storage.service';

import { DatePipe } from '@angular/common';
import { AssignOrderNoTab } from 'src/app/core/helpers/hand-accesibility/assign-order-no-tabs';
import { AssignOrderTab } from 'src/app/core/helpers/hand-accesibility/assign-order-tab';
import { HandAccesibility } from 'src/app/core/helpers/hand-accesibility/hand-accesibility';
import { MassQueriesService } from './../../../mass-queries/services/mass-queries.service';


@Component({
	selector: 'app-process-summary',
	templateUrl: './process-summary.component.html',
	styleUrls: ['./process-summary.component.scss']
})
export class ProcessSummaryComponent implements OnInit {
	@Input() title: string;
	@Input() companyData: IContribuyente;
	@Input() userloggedin: IUser;
  //@Input() tabindexes: any;

	userLogged: IUser;
	loading = false;
	items: Array<any> = [];
	maxItems = 3;

	constructor(
		private _queryServices: MassQueriesService,
		private _router: Router,
		private _storage: LocalStorageService,private datePipe: DatePipe
		) { }

	async ngOnInit() {
		this.userLogged = this._storage.getItemJSON(environment.LOCAL_STORAGE.USER_LOGGED_IN);
    this.getData();
	}

  setTabIndex(){

    let i:number; let j:number; let q:number=0; let r:number=0; let o:number=0; let z:number=0;
    let k: number = HandAccesibility.DomObject.filter(a=>a.front==='home').length;
    let objectsClass = HandAccesibility.DomObjectClass.filter(a=>a.front=='home');

    /*k = AssignOrderTab.setTabsFromIndexDom(1,'home');*/

    k++;
    z = AssignOrderTab.setTabsFromIndexDom(k,'home-left');

    for (i = 0; i < objectsClass.length; i++) {
      let objDomClass = document.getElementsByClassName (objectsClass[i].object);
      for (j = 0; j <= objDomClass.length; j++) {
        let objDom = objDomClass[j];
        q=z+j;
        if (objDom!=null) objDom.setAttribute("tabindex",q.toString());
      }
    }

    //nav home, right side

    q++;
    r = AssignOrderTab.setTabsFromIndexDom(q,'home-right');

    r++;
    let objDomProcess = HandAccesibility.DomObjectClass.filter(a=>a.front==='process');
    for (i = 0; i < objDomProcess.length; i++) {
      let objDomClass = document.getElementsByClassName(objDomProcess[i].object);
      for (j = 0; j <= objDomClass.length; j++) {
        o=r+j;
        let objDom = objDomClass[j];
        if (objDom!=null) objDom.setAttribute("tabindex",o.toString());
      }
    }


    q++;
    r = AssignOrderTab.setTabsFromIndexDom(q,'home-retreat');

    /*r++;
    let objDomRetreat  = HandAccesibility.DomObjectClass.filter(a=>a.front==='retreat');
    for (i = 0; i < objDomRetreat.length; i++) {
      let objDomClass = document.getElementsByClassName(objDomProcess[i].object);
      for (j = 0; j <= objDomClass.length; j++) {
        o=r+j;
        let objDom = objDomClass[j];
        if (objDom!=null) objDom.setAttribute("tabindex",o.toString());
      }
    }*/

    //tab calendar
    /*o++;
    o = AssignOrderTab.setTabsFromIndexDom(o,'calendar');*/
    AssignOrderNoTab.setNonFocusFromLabel('mat-expansion-panel-header');

  }

  private getTime(date: any) {
		return date != null ? date : 0;
  }


	public sortByDueDate(data) {
		let res = data.sort((a: any, b: any) => {
			return this.getTime(b.timestamp) - this.getTime(a.timestamp);
		});
		return res;
	}

	getData() {
    this.loading = true;
		let nombre = (this.companyData && this.companyData.nombre) ? this.companyData.nombre : '';
		let docNumberCompany = (this.companyData && this.companyData.numeroDocumento) ? this.companyData.numeroDocumento : '';
		const data = {
			idEmpresa: docNumberCompany
		};

		this._queryServices.getData(data)
		.pipe(
        finalize(() => {setTimeout(()=>this.setTabIndex(), 100);}),
			map(result => {
					if (result && result.result[0] && result.result[0].success && result.listQueueTask) {
						let res = this.sortByDueDate(result.listQueueTask);

						res.forEach((item: any, index) => {
							if (index < this.maxItems) {
								item.data = JSON.parse(item.body);
								this.items.push(item);
							}
						});
					} else if (result.result && result.result[0] && result.result.description) {
						alert(result.result[0].description);
					}
					this.loading = false;

				}
				),
			)
		.subscribe();
		this.loading = false;


	}


	downloadElement(item) {
		if (item.data && item.data.information && item.data.information.url) {
			const auxLink = document.createElement('a');
			document.body.appendChild(auxLink);
			const url = item.data.information.url;
			auxLink.href = url;
			auxLink.target = '_blank';
      auxLink.hidden = true;
      auxLink.setAttribute("aria-label", "true");
      auxLink.download = 'name';
			auxLink.click();
			window.URL.revokeObjectURL(url);
		}
	}

	showElement(proceso) {
		this._queryServices.setDataInfo(proceso);
		this._router.navigate(['/' +
			RoutingPath.appRouting.components.mass_queries.path
			+'/'+RoutingPath.appRouting.components.mass_queries.pages.detail.path
			]);
	}

	openLink() {
		this._router.navigate([RoutingPath.appRouting.components.mass_queries.path]);
	}

}
